import React from 'react';

export const Stretched = ({ children }: { children: React.ReactNode }) => (
  <div className="stretch">{children}</div>
);
